export { Modal } from './Modal'
export { ModalCloseButton } from './ModalCloseButton'
export {
  StyledModalBody as ModalBody,
  StyledModalFooter as ModalFooter,
  StyledModalHeader as ModalHeader,
} from './styled'
